import { CountriesConfigurationResponse } from "./types";

export const mockCountriesConfigurationResponse: CountriesConfigurationResponse = [
  {
    id: 1,
    name: "Polska",
    alias: "PL",
    code: "POL",
    nationId: 616,
    oftenUsed: true,
    currency: {
      id: 1,
      code: "PLN",
      name: "Polski Złoty",
    },
  },
  {
    id: 2,
    name: "Niemcy",
    alias: "DE",
    code: "DEU",
    nationId: 276,
    oftenUsed: true,
    currency: {
      id: 2,
      code: "EUR",
      name: "Euro",
    },
  },
  {
    id: 3,
    name: "Czechy",
    alias: "CZ",
    code: "CZE",
    nationId: 203,
    oftenUsed: false,
    currency: {
      id: 3,
      code: "CZK",
      name: "Korona Czeska",
    },
  },
  {
    id: 4,
    name: "Francja",
    alias: "FR",
    code: "FRA",
    nationId: 250,
    oftenUsed: false,
    currency: {
      id: 2,
      code: "EUR",
      name: "Euro",
    },
  },
  {
    id: 5,
    name: "Wielka Brytania",
    alias: "GB",
    code: "GBR",
    nationId: 826,
    oftenUsed: true,
    currency: {
      id: 4,
      code: "GBP",
      name: "Funt Szterling",
    },
  },
]
